import { PATH } from '../constants';

let sndManager = null;
let musicLoop = null;

// -------------------------------------------------------
// Init
// -------------------------------------------------------

export const initMusic = () => {
  if (sndManager === null) {
    const { DeSnd } = window;
    sndManager = new DeSnd.SoundManager();
    sndManager.fadeDuration = 500;
    sndManager.mute = true;

    // start atmo
    musicLoop = sndManager.addSound('atmo-top', `${PATH.SND}music`);
    musicLoop.loop = true;
    musicLoop.play();
  }
};

// -------------------------------------------------------
// Main controls
// -------------------------------------------------------

export const muteSwitch = () => {
  sndManager.mute = !sndManager.mute;
  return sndManager.mute;
};

export const soundBlockState = () =>
  sndManager && sndManager.context && sndManager.context.state === 'suspended';



// WEBPACK FOOTER //
// ./src/utils/SoundManager.js